import React from 'react';

const UserAnalyticsPanel = ({ userData, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="space-y-3">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900">User Analytics</h3>
        <span className="text-sm text-gray-500">
          {userData?.timestamp ? new Date(userData.timestamp).toLocaleTimeString() : 'Loading...'}
        </span>
      </div>

      <div className="space-y-6">
        {/* Total Users */}
        <div className="text-center p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg">
          <div className="text-4xl font-bold text-blue-600">
            {userData?.total_users || 0}
          </div>
          <div className="text-sm text-gray-700 mt-1">Total Clients</div>
        </div>

        {/* New Signups */}
        <div className="grid grid-cols-3 gap-3">
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600">
              {userData?.new_signups_today || 0}
            </div>
            <div className="text-xs text-gray-600">Today</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600">
              {userData?.new_signups_week || 0}
            </div>
            <div className="text-xs text-gray-600">This Week</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600">
              {userData?.new_signups_month || 0}
            </div>
            <div className="text-xs text-gray-600">This Month</div>
          </div>
        </div>

        {/* Active Users */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Active Users</div>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-green-50 p-3 rounded-lg">
              <div className="text-2xl font-bold text-green-700">
                {userData?.active_users_7d || 0}
              </div>
              <div className="text-xs text-gray-600">Last 7 Days</div>
            </div>
            <div className="bg-blue-50 p-3 rounded-lg">
              <div className="text-2xl font-bold text-blue-700">
                {userData?.active_users_30d || 0}
              </div>
              <div className="text-xs text-gray-600">Last 30 Days</div>
            </div>
          </div>
        </div>

        {/* Subscription Tiers */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Subscription Distribution</div>
          <div className="space-y-2">
            {userData?.users_by_tier && Object.entries(userData.users_by_tier).map(([tier, count]) => (
              <div key={tier} className="flex items-center justify-between">
                <span className="text-sm text-gray-700 capitalize">{tier}</span>
                <span className="font-semibold text-gray-900">{count}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Trial vs Paid */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Conversion Metrics</div>
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-900">
                {userData?.trial_vs_paid?.trial || 0}
              </div>
              <div className="text-xs text-gray-600">Trial Users</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-orange-600">
                {userData?.trial_vs_paid?.paid || 0}
              </div>
              <div className="text-xs text-gray-600">Paid Users</div>
            </div>
          </div>
          <div className="text-center mt-3 p-2 bg-orange-50 rounded">
            <div className="text-sm text-gray-700">
              Conversion Rate: <span className="font-bold text-orange-600">
                {userData?.trial_vs_paid?.conversion_rate?.toFixed(1) || '0.0'}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAnalyticsPanel;

